export function preloadImage (url) {
  try {
    const img = new Image()
    img.src = url
  } catch (e) {
    console.log(':(')
  }
}
